import axios from 'axios'
import Qs from 'qs'
import wx from 'weixin-js-sdk';

import {getServer} from '@/utils/share'
import {setStore, getStore, removeStore} from '@/config/mUtils'
import {APPID} from '@/service/getData';
//提示弹窗
import Vue from 'vue'
import {Alert} from '@/wc-messagebox'
Vue.use(Alert);

/**
 * 获取链接参数
 */
export const GetQueryString = (name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
};

/**
 * 调用微信授权
 */
export const getWxAuth = (callback) => {
  let appId = APPID;

  const query = Qs.parse(location.hash.substring(3));
  let code = query.code || GetQueryString("code") || "";
  let state = query.state || GetQueryString("state") || "";
  let scenicKey = query.scenicKey || GetQueryString("scenicKey") || "";
  let scenicId = query.scenicId || GetQueryString("scenicId") || "";

  var headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  if(scenicKey){
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'scenicKey': scenicKey
    };
  }

  if (code == "" || code == null || code == "undefined") {
    Vue.prototype.$alert({
      title: '微信授权',
      content: '请点击下方【允许】按钮，完成授权使用完整服务',
      btnText: '允许',
      style: 'color:#3CC51F;font-weight:bold;'
    }).then(function(res){
      if(res == 'ok') {
        let locaurl_base = location.href.split('#')[0].split('?')[0];
        window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" + locaurl_base + "&response_type=code&scope=snsapi_userinfo&state=&connect_redirect=1#wechat_redirect");
      }
    });


  } else {
    var url = getServer().admin;
    axios.post( url + 'rest/user/code' , Qs.stringify({code: code}), {
      headers: headers
    }).then(function (data) {
      console.log(data);
      if (callback) callback(data)
    });

  }
};

//判断是否需要景区授权
export const checkScenicAuth = (scenicKey,scenicId,callback) => {
  var headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  if(scenicKey){
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'scenicKey': scenicKey
    };
  }

  var url = getServer().admin;
  axios.post( url + 'rest/scenic/code' , Qs.stringify({
    openid: getStore("userInfo").openid,
    scenicId: scenicId,
    time: (new Date().getTime())
  }), {
    headers: headers
  }).then(function (data) {
    if (callback) callback(data)
  });
};

//获取景区二次授权
export const getScenicAuth = (scenicKey,appdata,callback) => {
  let appId = appdata.appid;

  const query = Qs.parse(location.hash.substring(3));
  let code = query.code || GetQueryString("code") || "";
  let state = query.state || GetQueryString("state") || "";

  var headers = {
    'Content-Type': 'application/x-www-form-urlencoded'
  };
  if(scenicKey){
    headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'scenicKey': scenicKey
    };
  }

  console.log(code);

  if (code == "" || code == null || code == "undefined") {
    //let locaurl_base = location.href.split('#')[0].split('?')[0];
    let locaurl_base = encodeURIComponent(location.href);
    let component_appid = 'wx651146b46418aa08';
    //window.location = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" + locaurl_base + "&response_type=code&scope=snsapi_base&component_appid="+ component_appid +"&state=&connect_redirect=1#wechat_redirect";
    //https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxe47c787c774b563e&redirect_uri=https://jpjs.geeker.com.cn/dist/cbtourist/index.html#/&response_type=code&scope=snsapi_base&component_appid=wx651146b46418aa08&state=&connect_redirect=1#wechat_redirect
    window.location.replace("https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" + locaurl_base + "&response_type=code&scope=snsapi_base&component_appid="+ component_appid +"&state=&connect_redirect=1#wechat_redirect");

  } else {
    var url = getServer().admin;
    axios.post( url + 'rest/user/scenicCode' , Qs.stringify({
      openid: getStore("userInfo").openid,
      code: code
    }), {
      headers: headers
    }).then(function (data) {
      if (callback) callback(data)
    });
  }
};



// WEBPACK FOOTER //
// ./src/utils/author.js